import type { ReactNode } from 'react';
import { Card } from './Card.tsx';

interface Props {
  icon?: ReactNode;
  title: string;
  body?: ReactNode;
  action?: ReactNode;
}

export function EmptyState({ icon, title, body, action }: Props): React.ReactElement {
  return (
    <Card>
      <div className="flex flex-col items-center justify-center gap-3 py-8 text-center">
        {icon && <div className="text-[var(--color-muted)]">{icon}</div>}
        <h3 className="text-base font-semibold text-[var(--color-header)]">{title}</h3>
        {body && <div className="max-w-md text-sm text-[var(--color-muted)]">{body}</div>}
        {action}
      </div>
    </Card>
  );
}
